import { TeamWhereInput } from '@/@generated/codegen/API';
import { useQueryParams } from '@/hooks/useQueryParams';
import { QUERY_PARAM_GLOBAL_FILTER_KEY } from '@/hooks/useTableQueryParamsUtils';
import { parseDateQueryParam } from '@/utils/query-params/parseDateQueryParam';
import { parseStringQueryParam } from '@/utils/query-params/parseStringQueryParam';
import { useOrderByQueryParam } from '@/utils/query-params/useOrderByQueryParam';
import { usePaginationQueryParam } from '@/utils/query-params/usePaginationQueryParam';

export const useAdminTeamListQueryParams = (pageSize: number, prefix: string) => {
  const queryObject = useQueryParams(
    [QUERY_PARAM_GLOBAL_FILTER_KEY, 'createdAt', 'updatedAt', 'name'],
    prefix
  );

  const { q, createdAt, updatedAt, name } = queryObject;
  const orderByArgs = useOrderByQueryParam(prefix);
  const paginationArgs = usePaginationQueryParam(pageSize, prefix);
  const where: TeamWhereInput = {
    AND: [
      q
        ? {
            OR: [{ id: parseStringQueryParam(q) }, { name: parseStringQueryParam(q) }],
          }
        : {},
      {
        name: parseStringQueryParam(name),
        createdAt: parseDateQueryParam(createdAt),
        updatedAt: parseDateQueryParam(updatedAt),
      },
    ],
  };

  return {
    paginationArgs,
    orderByArgs,
    where,
  };
};
